import React, { useContext, useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";
import { Box, Paper, Typography, Grid  } from "@material-ui/core";
import DailyHiLo from "../../components/DailyHiLo";
import { menuDetailsContext } from '../../../../../contexts/MenuDetailsProvider';

import {
    setLastTrade,
    FETCH_MLFORECAST_REQUEST,
    FETCH_MLFORECAST_RESET,
    FETCH_MLFORECAST_RESET_THIRD,
} from "store/actions";

import { makeStyles, useTheme } from "@material-ui/styles";
import colors from 'assets/scss/_themes-vars.module.scss';

import {
  createChart,
  createPriceLine,
  CrosshairMode,
} from "lightweight-charts";
import CoinContext from "contexts/CoinContext";
import { useSelector, useDispatch } from "react-redux";
import I from "immutable";
import axios from "axios";
// 1. No duplicates in the CandleStick Time Series
// 2. All time values must be Ascending order (increasing)
// 3. No NULL values in OHLC for that timestamp

const useStyles = makeStyles((theme) => ({
}));

const MarketShareAreaChartCard = ({chart_index}) => {

  const [previousCoin, setPreviousCoin] = useState("");
  const [previousTS, setPreviousTS] = useState(0);
  const [prevMacdTS, setPrevMacdTS] = useState(0);
  const [fetchTrigger, setFetchTrigger] = useState(0); // 1. The state to trigger the effect
  const [chartUpdated, setChartUpdated] = useState(false); // 1. The state to trigger the effect
  const [predict, setPredict] = useState(false); // 1. The state to trigger the effect
  const [legend, setLegend] = useState({
        open: 0,
        high: 0,
        low: 0,
        close: 0,
  });
  const [popup, setPopup] = useState({
    open: false,
    x: 0,
    y: 0,
    candle: null,
  });

  let second_mlpData = undefined;
  let third_mlpData = undefined;
  let fifth_mlpData = undefined;

  const handleClick = () => {
    // 2. Update the state on button click
    setFetchTrigger(prevTrigger => prevTrigger + 1);
    // TMD console.log( 'HandleClick: ' + fetchTrigger);
    // NOT YET setChartUpdated(false);
  };


  const chartContainerRef = useRef();
  const classes = useStyles();
  const dispatch = useDispatch();
  const theme = useTheme();
  const cornsilk = (theme.palette.mode === 'dark') ? 'white' : colors.cornsilkDarkTakyon;
  const whiteTakyon = (theme.palette.mode === 'dark') ? colors.whiteLightTakyon : colors.whiteDarkTakyon;
  const green = (theme.palette.mode === 'dark') ? colors.successLightTakyon : colors.successMain;
  const red = (theme.palette.mode === 'dark') ? colors.errorLightTakyon : colors.errorDarkTakyon;
  const bgcolor = (theme.palette.mode === 'dark') ? '#15140f' : 'white';
  // const bgcolor = theme.palette.background.paper;

  const chart = useRef();
  const series = useRef();
  const avgLine = useRef();
  const priceLine = useRef();
  const lineSeries = useRef();
  const second_lgbSeries = useRef();
  const third_lgbSeries = useRef();
  const fifth_lgbSeries = useRef();

  const current_interval = useSelector((state) => state.chart.ohlcInterval);

  const symbolRef = useRef(previousCoin);
  const intervalRef = useRef(current_interval);

  const resizeObserver = useRef();
  // NOT YET TODO const { coin } = useContext(CoinContext);
  const [lcoin, setLcoin] = useContext(menuDetailsContext);

  // console.log( 'Sameer Chart prev: ' + previousCoin + ', coin: ' + coin + ', lcoin: ' + lcoin + ', chart_index: ' + chart_index);
  if (previousCoin !== lcoin)
  {
    setPreviousCoin(lcoin);
    setFetchTrigger(prevTrigger => prevTrigger + 1);
    setChartUpdated(false);
  }
  else if ( lcoin === "")
  {
    // TMD console.log( 'Sameer Chart lcoin === "" ' + previousCoin + ', ' + lcoin );
    setPreviousCoin("NBIS");
    setFetchTrigger(prevTrigger => prevTrigger + 1);
    setChartUpdated(false);
  }
  const ohlc_done = useSelector((state) => {return state.coins.ohlc_done;});

  useEffect(() => {
    // TMD console.log( 'NOW RESETTING CHART_UPDATED TO false FOR ohlc_done4 = false, ' + lcoin);
    setChartUpdated(false);
    setFetchTrigger(prevTrigger => prevTrigger + 1);
  }, [ohlc_done]);

  useEffect(() => {
        // TMD console.log( 'HEREs WHERE WE NEED TO RESET THE LGB SERIES -------------------> ' + previousCoin);
        second_mlpData = undefined;
        third_mlpData = undefined;
        fifth_mlpData = undefined;
        if ( second_lgbSeries !== undefined && second_lgbSeries.current !== undefined)
            second_lgbSeries.current.setData([]);
        if ( third_lgbSeries !== undefined && third_lgbSeries.current !== undefined)
            third_lgbSeries.current.setData([]);
        if ( fifth_lgbSeries !== undefined && fifth_lgbSeries.current !== undefined)
            fifth_lgbSeries.current.setData([]);

      symbolRef.current = previousCoin;
  }, [previousCoin]);

  useEffect(() => {
      intervalRef.current = current_interval;
  }, [current_interval]);

  const ltp = useSelector((state) => {
    return ((state.coins.kraken_asset_pairs_loaded && state.coins.kraken_asset_pairs.get(lcoin) && state.coins.kraken_asset_pairs.get(lcoin).ltp) || 0.0);
  });

  const predict_history = useSelector((state) => (state.chart.mapPredictHistory.get(symbolRef.current + '-' + String(intervalRef.current)) || undefined));

  // TMD console.log( "SAMEER -------- OHLC_DONE_CHART_JS ----- : " + ohlc_done);

  let markers_positive = [];
  let markers_negative = [];

  let marker_start_ts = 0;
  let marker_start_color = 'lightgreen';
  const portfolio = useSelector((state) => {
    if (state.coins.kraken_asset_pairs) {
      let item = state.coins.kraken_asset_pairs.get(lcoin);
      if (item !== undefined && item.swl_positive_marker !== undefined) 
      {
        markers_positive = item.swl_positive_marker;
        marker_start_color = 'green';
      } 
      if (item !== undefined && item.swl_negative_marker !== undefined) 
      {
        markers_negative = item.swl_negative_marker;
        marker_start_color = 'red';
      }

      if ((item !== undefined) && (item.position !== undefined) && (item.position.remaining_qty !== undefined)) {
        return [
          item.position.remaining_qty.toFixed(2),
          (item.position.remaining_qty * ltp).toFixed(2),
          item.position.realized,
          item.position.unrealized,
          item.position.remaining_avg_price,
        ];
      } else {
        return [0, 0, 0, 0, 0];
      }
    } else {
      return [0, 0, 0, 0, 0];
    }
  });

    const avg_px = portfolio[4];
    let avg_ts = 0;
    let avg_df = 1000000.0;

    const lastTrade = useSelector((state) => {

        /*
        if ((state.chart.mapLastTrade) && (state.chart.mapLastTrade.get(lcoin)))
        {
            return state.chart.mapLastTrade.get(lcoin);
        }
        */
        let items = [];

        if (state.takyon.mapTrades !== undefined) {
          let count = 0;
          state.takyon.mapTrades.forEach((item, i) => {
            if (item.pair === lcoin) {
              items.push(item);
            }
          });
        }

        items.sort(function(a, b) {
            return (b.time_ms - a.time_ms);
        });
        return items;
    });


  let lwData =  useSelector((state) => {
    let data = []; 
    // TMD console.log( state.chart.chartData);
    Object.keys(state.chart.chartData).map((key) => {
        if ( key === lcoin)
        {
            // TMD console.log( state.chart.chartData[key]);
            const uniqObj = state.chart.chartData[key];
            let prevTS = 0;
            uniqObj.map((item, index) => {
                if ( item.time > prevTS)
                {
                    prevTS = item.time;
                    data = [...data, item];
                }
            });
        }
    });
    return data;
  });


  const second_mlforecast_loading = useSelector((state) => state.chart.second_mlforecast_loading);
  const third_mlforecast_loading = useSelector((state) => state.chart.third_mlforecast_loading);
  const fifth_mlforecast_loading = useSelector((state) => state.chart.mlforecast_loading);


  // TMD console.log( 'ML_FORECAST_LOADING--------------------- ' + symbolRef.current + ', 0th: ' + mlforecast_loading + ', 3rd: ' + third_mlforecast_loading + ', 5th: ' + fifth_mlforecast_loading);


  second_mlpData =  useSelector((state) => {
        let lines = I.Map();
        let pLGBMRegressor = [];

        try
        {
            // console.log( 'mapMLForecast.get ' + symbolRef.current);
            const prediction = state.chart.mapSecondMLForecast.get(symbolRef.current + '-15');
            if (prediction !== undefined)
            {
                prediction.map((key) => {
                    pLGBMRegressor = [...pLGBMRegressor, {time: (0*60*60+key.ds/1000), value: key.LGBMRegressor}];
                });

                lines = lines.set('LGBMRegressor', pLGBMRegressor);

            } else {
                if (predict_history !== undefined)
                {
                    predict_history.map((key) => {
                        pLGBMRegressor = [...pLGBMRegressor, {time: (0*60*60+key.ds/1000), value: key.LGBMRegressor}];
                    });

                    lines = lines.set('LGBMRegressor', pLGBMRegressor);
                    // TMD console.log( '-------- LINES from PREDICT_HISTORY -------------- ' + symbolRef.current + '-' + String(intervalRef.current) + ', size: ' + lines.length);

                } else {
                    // TMD console.log( 'MLP_DATA prediction === undefined');
                    lines = undefined;
                }
            }
        } catch(e) {
            console.log(e);
            lines = undefined;
        }
        return lines;
  });

  third_mlpData =  useSelector((state) => {
        let lines = I.Map();
        let pLGBMRegressor = [];

        try
        {
            // console.log( 'mapMLForecast.get ' + symbolRef.current);
            const prediction = state.chart.mapThirdMLForecast.get(symbolRef.current + '-30');
            if (prediction !== undefined)
            {
                prediction.map((key) => {
                    pLGBMRegressor = [...pLGBMRegressor, {time: (0*60*60+key.ds/1000), value: key.LGBMRegressor}];
                });

                lines = lines.set('LGBMRegressor', pLGBMRegressor);

            } else {
                if (predict_history !== undefined)
                {
                    predict_history.map((key) => {
                        pLGBMRegressor = [...pLGBMRegressor, {time: (0*60*60+key.ds/1000), value: key.LGBMRegressor}];
                    });

                    lines = lines.set('LGBMRegressor', pLGBMRegressor);
                    // TMD console.log( '-------- LINES from PREDICT_HISTORY -------------- ' + symbolRef.current + '-' + String(intervalRef.current) + ', size: ' + lines.length);

                } else {
                    // TMD console.log( 'MLP_DATA prediction === undefined');
                    lines = undefined;
                }
            }
        } catch(e) {
            console.log(e);
            lines = undefined;
        }
        return lines;
  });

  fifth_mlpData =  useSelector((state) => {
        let lines = I.Map();
        let pLGBMRegressor = [];

        try
        {
            // console.log( 'mapMLForecast.get ' + symbolRef.current);
            const prediction = state.chart.mapMLForecast.get(symbolRef.current + '-5');
            if (prediction !== undefined)
            {
                prediction.map((key) => {
                    pLGBMRegressor = [...pLGBMRegressor, {time: (0*60*60+key.ds/1000), value: key.LGBMRegressor}];
                });

                lines = lines.set('LGBMRegressor', pLGBMRegressor);

            } else {
                if (predict_history !== undefined)
                {
                    predict_history.map((key) => {
                        pLGBMRegressor = [...pLGBMRegressor, {time: (0*60*60+key.ds/1000), value: key.LGBMRegressor}];
                    });

                    lines = lines.set('LGBMRegressor', pLGBMRegressor);
                    // TMD console.log( '-------- LINES from PREDICT_HISTORY -------------- ' + symbolRef.current + '-' + String(intervalRef.current) + ', size: ' + lines.length);

                } else {
                    // TMD console.log( 'MLP_DATA prediction === undefined');
                    lines = undefined;
                }
            }
        } catch(e) {
            console.log(e);
            lines = undefined;
        }
        return lines;
  });

  let lwMACD =  useSelector((state) => {
    let data = []; 
    // TMD console.log( state.chart.chartData);
    Object.keys(state.chart.chartData).map((key) => {
        if ( key === lcoin)
        {
            // TMD console.log( state.chart.chartData[key]);
            const uniqObj = state.chart.chartData[key];
            let prevTS = 0;
            uniqObj.map((item, index) => {
                if ( item.macd > 0 && item.time > prevTS)
                {
                    prevTS = item.time;
                    data = [...data, {time: item.time, value: item.macd}];
                }
            });
        }
    });
    return data;
  });

  useEffect(() => {
    // TMD console.log( 'USE EFFECT------ CREATE CHART');
    // init chart, do not modify here
    chart.current = createChart(chartContainerRef.current, {
      height: 400,
      width: 800,
      layout: {
        backgroundColor: bgcolor,
        textColor: cornsilk,
      },
      grid: {
        vertLines: {
            visible: false,
            color: "#111",
        },
        horzLines: {
            visible: false,
            color: "#111",
        },
      },
      crosshair: {
        vertLine: {
          color: "#333",
          width: 0.1,
          style: 0,
          visible: true,
          labelVisible: true,
        },
        horzLine: {
          color: "#333",
          width: 0.1,
          style: 0,
          visible: true,
          labelVisible: true,
        },
        mode: CrosshairMode.Normal,
      },
      priceScale: {
        borderColor: "#888",
        borderVisible: false,
      },
      alignLabels: true,
      timeScale: {
        rightOffset: 10,
        barSpacing: 8,
        fixLeftEdge: false,
        lockVisibleTimeRangeOnResize: true,
        rightBarStaysOnScroll: true,
        borderVisible: false,
        borderColor: "#888",
        visible: true,
        timeVisible: true,
        secondsVisible: true,
      },
    });

    // upColor: "#4bffb5",
    // downColor: "#ff4976",
    /*
    TODO denys orig
     *
    const candleSeries = chart.current.addCandlestickSeries({
      width: '100%',
      upColor: "#000000",
      downColor: "#ff4976",
      borderUpColor: "#4bffb5",
      borderDownColor: "#ff4976",
      wickUpColor: "#4bffb5",
      wickDownColor: "#ff4976",
    });
    */

    const candleSeries = chart.current.addCandlestickSeries({
      upColor: green,
      downColor: red,
      borderUpColor: green,
      borderDownColor: red,
      wickUpColor: green,
      wickDownColor: red,
    });

    candleSeries.setData([
            {time: 1773166429, open: 9.35, high: 9.35, low: 9.35, close: 9.35}, 
            {time: 1773166436, open: 9.35, high: 9.36, low: 9.34, close: 9.34}, 
            {time: 1773166437, open: 9.35, high: 9.35, low: 9.35, close: 9.35}, 
            {time: 1773166441, open: 9.35, high: 9.35, low: 9.34, close: 9.34}, 
            {time: 1773166451, open: 9.35, high: 9.35, low: 9.33, close: 9.33}, 
            {time: 1773166453, open: 9.34, high: 9.34, low: 9.32, close: 9.33}, 
            {time: 1773166454, open: 9.33, high: 9.33, low: 9.33, close: 9.33}, 
            {time: 1773166480, open: 9.35, high: 9.36, low: 9.32, close: 9.32}, 
            {time: 1773166489, open: 9.32, high: 9.32, low: 9.31, close: 9.31}, 
            {time: 1773166491, open: 9.31, high: 9.32, low: 9.29, close: 9.3}, 
            {time: 1773166492, open: 9.3, high: 9.32, low: 9.3, close: 9.32}, 
            {time: 1773166514, open: 9.32, high: 9.37, low: 9.29, close: 9.31}, 
            {time: 1773166520, open: 9.31, high: 9.32, low: 9.28, close: 9.28}, 
            {time: 1773166521, open: 9.28, high: 9.29, low: 9.28, close: 9.29}, 
            {time: 1773166522, open: 9.29, high: 9.3, low: 9.29, close: 9.3}, 
            {time: 1773166535, open: 9.31, high: 9.32, low: 9.31, close: 9.31}, 
            {time: 1773166540, open: 9.31, high: 9.34, low: 9.31, close: 9.31}
    ]);

    avgLine.current = candleSeries.createPriceLine({
      price: "0.00",
      color: "orange",
      lineWidth: -1,
      lineStyle: 0,
      axisLabelVisible: true,
      title: "avg",
    });

    lineSeries.current = chart.current.addLineSeries({
        color: '#2962FF',
        lineWidth: 2,
    });

    second_lgbSeries.current = chart.current.addLineSeries({
        color: 'red',
        lineWidth: 2,
        priceLineVisible: false,
    });
    third_lgbSeries.current = chart.current.addLineSeries({
        color: 'orange',
        lineWidth: 2,
        priceLineVisible: false,
    });
    fifth_lgbSeries.current = chart.current.addLineSeries({
        color: 'yellow',
        lineWidth: 2,
        priceLineVisible: false,
    });

    const temp_data = [
{time: 1782968400, value: 16.5791380318},
{time: 1782969300, value: 16.5887645941},
{time: 1782970200, value: 16.6037608402},
{time: 1782971100, value: 16.6292586789},
{time: 1782972000, value: 16.6644639509},
{time: 1782972900, value: 16.6921119931},
{time: 1782973800, value: 16.712092867},
{time: 1782974700, value: 16.723003761},
{time: 1782975600, value: 16.7446067924},
{time: 1782976500, value: 16.7613711471},
{time: 1782977400, value: 16.7735911322},
{time: 1782978300, value: 16.7873145559},
{time: 1782979200, value: 16.7973630698},
{time: 1782980100, value: 16.8065575746},
{time: 1782981000, value: 16.8113889717},
{time: 1782981900, value: 16.811948703},
{time: 1782982800, value: 16.8119073761},
{time: 1782983700, value: 16.8139946071},
{time: 1782984600, value: 16.8209806657},
{time: 1782985500, value: 16.8257491288},
{time: 1782986400, value: 16.8243367801},
{time: 1782987300, value: 16.8148956713},
{time: 1782988200, value: 16.8241757436},
{time: 1782989100, value: 16.8342747997},
{time: 1782990000, value: 16.8462124112},
{time: 1782990900, value: 16.8548364169},
{time: 1782991800, value: 16.861242978},
{time: 1782992700, value: 16.8717026902},
    ];


/***
chart.current.subscribeCrosshairMove(param => {

    if (
        !param.time ||
        param.point === undefined
    ) {
        return;
    }

        const data = param.seriesPrices.get(candleSeries);
        console.log( 'CURRENT_CHART_CLICKED ' + popup.open);
        const open = !popup.open;
        console.log(data);
        if ( (data !== undefined) && (data.open !== undefined))
        {
            setLegend({
                open: data.open,
                high: data.high,
                low: data.low,
                close: data.close,
            });
                setPopup({
                    open: open,
                    x: param.point.x,
                    y: param.point.y,
                    data,
                });
        }
});
***/

    /*******
    chart.current.subscribeClick(function(param) {
        // TMD console.log(param);

        // NO POINT CLICKED
        if ( !param.point || !param.time || !param.seriesPrices) {
                setPopup({
                    open: false,
                    x: param.point.x,
                    y: param.point.y,
                    candle: {open:0,high:0,low:0,close:0},
                });
          return;
        }
        const data = param.seriesPrices.get(candleSeries);
        if ( data === undefined)
        {
                setPopup({
                    open: false,
                    x: param.point.x,
                    y: param.point.y,
                    candle: {open:0,high:0,low:0,close:0},
                });
        }

        // TMD console.log( 'CURRENT_CHART_CLICKED ' + popup.open);
        const open = !popup.open;
        // TMD console.log(data);
        if ( (data !== undefined) && (data.open !== undefined))
        {
            setLegend({
                open: data.open,
                high: data.high,
                low: data.low,
                close: data.close,
            });
                setPopup({
                    open: open,
                    x: param.point.x,
                    y: param.point.y,
                    data,
                });
        }
    });
    */
    series.current = candleSeries;
 
  }, []);

  
  useEffect(() => {
    //update chart data here
    // TMD console.log( 'USE EFFECT------ UPDATE ' + chartUpdated + ' CHART ------> ' + lwData.length + ', ohlc_done: ' + ohlc_done);
    if (series.current) {
        // Let's add one bar with LTP to this
        if ( (lwData.length > 1) && ohlc_done)
        {
                // TMD console.log( 'Trying to UPDATE  MLForecast PREDICTIONS ' + symbolRef.current + ', ' + second_mlforecast_loading);
                // TMD console.log(second_mlpData);
                if ( (second_mlpData !== undefined) )
                {
                        // TMD console.log( 'updating MLForecast PREDICTIONS ' + symbolRef.current);
                        // TMD console.log(second_mlpData.get('LGBMRegressor'));

                        second_lgbSeries.current.setData(second_mlpData.get('LGBMRegressor'));

                        dispatch( {type: FETCH_MLFORECAST_RESET, payload: {}});
                } else if ( second_mlpData === undefined) {
                        // TMD console.log( '1. MLForecast RESET_LINES ' + symbolRef.current + ', ' + second_mlforecast_loading);
                        second_lgbSeries.current.setData([]);
                        
                        dispatch( {type: FETCH_MLFORECAST_RESET, payload: {}});
                }
                if ( (third_mlpData !== undefined) )
                {
                        // TMD console.log( 'THIRD_THIRD_THIRD_ updating MLForecast PREDICTIONS ' + symbolRef.current);
                        // TMD console.log(third_mlpData.get('LGBMRegressor'));

                        third_lgbSeries.current.setData(third_mlpData.get('LGBMRegressor'));

                        dispatch( {type: FETCH_MLFORECAST_RESET_THIRD, payload: {}});
                } else if ( third_mlpData === undefined) {
                        // TMD console.log( 'THIRD_THIRD_THIRD_ 1. MLForecast RESET_LINES ' + symbolRef.current + ', ' + third_mlforecast_loading);
                        third_lgbSeries.current.setData([]);

                        dispatch( {type: FETCH_MLFORECAST_RESET_THIRD, payload: {}});
                }
                if ( (fifth_mlpData !== undefined) )
                {
                        // TMD console.log( 'FIFTH_FIFTH_FIFTH_ updating MLForecast PREDICTIONS ' + symbolRef.current);
                        // TMD console.log(fifth_mlpData.get('LGBMRegressor'));

                        fifth_lgbSeries.current.setData(fifth_mlpData.get('LGBMRegressor'));

                        dispatch( {type: FETCH_MLFORECAST_RESET, payload: {}});
                } else if ( fifth_mlpData === undefined) {
                        // TMD console.log( 'FIFTH_FIFTH_FIFTH_ 1. MLForecast RESET_LINES ' + symbolRef.current + ', ' + fifth_mlforecast_loading);
                        fifth_lgbSeries.current.setData([]);

                        dispatch( {type: FETCH_MLFORECAST_RESET, payload: {}});
                }

            // TMD console.log(lwData);
            let pData = lwData[lwData.length-1];
            let mData = lwMACD[lwMACD.length-1];
            if ( !chartUpdated) 
            {
                if (lwData.length > 19)
                {
                    // TMD console.log( 'SAMEER -------------- SET_D  ' + lcoin + ', ltp: ' + ltp + ', fetch: ' + fetchTrigger + ', len: ' + lwData.length);
                    series.current.setData(lwData);
                    if ( lwMACD.length > 5)
                    {
                        lineSeries.current.setData(lwMACD);
                        // TMD console.log( '------- setData(MACD) ----- ');
                        // TMD console.log( lwMACD);
                        if (mData !== undefined)
                        {
                            setPrevMacdTS(mData.time);
                        }
                    }
                        
                    setChartUpdated(true);
                    setPreviousTS(pData.time);
                } else {
                    // TMD console.log( 'SAMEER ------------UN_SET_D  ' + lcoin + ', ltp: ' + ltp + ', fetch: ' + fetchTrigger + ', len: ' + lwData.length);
                }
            } else {
                if ( pData !== undefined)
                {
                    pData.close = ltp;
                    // TMD console.log(pData);
                    if (previousTS <= pData.time)
                    {
                        // TMD console.log( 'SAMEER -------------- UPDATE ' + lcoin + ', ltp: ' + ltp + ', fetch: ' + fetchTrigger + ', len: ' + lwData.length);
                        series.current.update(pData);
                        setPreviousTS(pData.time);
                    }
                }
                if ( mData !== undefined)
                {
                    if ( prevMacdTS <= mData.time)
                    {
                        // TMD console.log( 'MACD   -------------- UPDATE ' + lcoin + ', ltp: ' + ltp + ', time: ' + mData.time + ', value: ' + mData.value);
                        // TMD console.log(mData);
                        lineSeries.current.update(mData);
                        setPrevMacdTS(mData.time);
                    }
                }
            }
            // TODO SAMEER NOT YET series.current.setData(lwData);

              let markers = [];
              if (markers_positive.length > 0)
              markers_positive.map((timestamp) => {
                // TMD console.log( 'SWL_POSITIVE MARKER ' + timestamp);
                      markers.push({
                        time: timestamp,
                        size: 2.4,
                        shape: "circle",
                        position: "inBar",
                        color: "lightgreen",
                        text: "",
                      });
                      markers.push({
                        time: timestamp,
                        size: 2.2,
                        shape: "circle",
                        position: "inBar",
                        color: "black",
                        text: "",
                      });
                      markers.push({
                        time: timestamp,
                        size: 1.4,
                        shape: "circle",
                        position: "inBar",
                        color: 'lightgreen',
                        text: "",
                      });
              });
              if (markers_negative.length > 0)
              markers_negative.map((timestamp) => {
                // TMD console.log( 'SWL_NEGATIVE MARKER ' + timestamp);
                      markers.push({
                        time: timestamp,
                        size: 2.4,
                        shape: "circle",
                        position: "inBar",
                        color: "red",
                        text: "",
                      });
                      markers.push({
                        time: timestamp,
                        size: 2.2,
                        shape: "circle",
                        position: "inBar",
                        color: "black",
                        text: "",
                      });
                      markers.push({
                        time: timestamp,
                        size: 1.4,
                        shape: "circle",
                        position: "inBar",
                        color: 'red',
                        text: "",
                      });
              });
             // TMD console.log(markers);
             if ( markers.length > 0)
              series.current.setMarkers(markers);
        } else {
            // TMD console.log( 'SAMEER --NO_OP NO_OP  NO_OP  ' + lcoin + ', ltp: ' + ltp + ', fetch: ' + fetchTrigger + ', len: ' + lwData.length);
        }
        /*
        if ( avg_px !== 0)
        {
            avgLine.current.applyOptions({
                price: avg_px,
            });
        }
        */


    }

  }, [ltp, ohlc_done, second_mlforecast_loading, lineSeries]);

  return (
    <>
          <div class={classes.chart} onClick={handleClick} ref={chartContainerRef} />
          <Box sx={{ position: "relative" }}>

            <div ref={chartContainerRef} />

            {popup.open && (

                <Paper
                    elevation={8}
                    sx={{
                        position: "absolute",
                        left: popup.x + 12,
                        top: popup.y - 12,

                        p: 2,
                        width: 260,

                        bgcolor: "#999",
                        color: "white",

                        borderRadius: 2,

                        zIndex: 1000,
                    }}
                >

                    <Typography fontWeight={700}>
                        Buy Signal
                    </Typography>

                    <Typography>
                        Open {legend.open}
                    </Typography>

                    <Typography>
                        High {legend.high}
                    </Typography>

                    <Typography>
                        Low {legend.low}
                    </Typography>

                    <Typography>
                        Close {legend.close}
                    </Typography>

                </Paper>

            )}

        </Box>
    </>
  );
};
export default React.memo(MarketShareAreaChartCard);
